import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import layout from '@/components/layout/layout'
import consumer from '@/components/consumer/consumer'

Vue.use(Router)

// const VueRouterPush = Router.prototype.push
// Router.prototype.push = function push (to) {
//   return VueRouterPush.call(this, to).catch(err => err)
// }

// let lvList = ['一级权限','二级权限','三级权限','四级权限','五级权限']
export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path:'/main',
      name:'main',
      component: layout,
      redirect:'/home',
      children:[
        {
          path:'/home',
          meta:{
            name:'主页',
          },
          component:consumer
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js